import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FrameIn } from 'projects/shared/src/interfaces/frame-in.interface';
import { FrameOutResponse } from 'projects/shared/src/interfaces/frame-out-response.interface';
import { Observable } from 'rxjs';
import { ShHeadersService } from '../headers/sh-headers.service';

@Injectable({
  providedIn: 'root',
})
export class ShDocumentsService {
  constructor(
    private http: HttpClient,
    private _shSharedHeaders: ShHeadersService
  ) {}

  upLoadPdf(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    return this.http.post<FrameOutResponse>(
      `${url}`,
      this._shSharedHeaders.buildBody(request),
      {
        headers: this._shSharedHeaders.buildHeaders(request, envHeaders),
      }
    );
  }

  getListLoadPdf(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    return this.http.post<FrameOutResponse>(
      `${url}`,
      this._shSharedHeaders.buildBody(request),
      {
        headers: this._shSharedHeaders.buildHeaders(request, envHeaders),
      }
    );
  }

  saveLoadPdf(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    return this.http.post<FrameOutResponse>(
      `${url}`,
      this._shSharedHeaders.buildBody(request),
      {
        headers: this._shSharedHeaders.buildHeaders(request, envHeaders),
      }
    );
  }

  shSendBase64(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    return this.http.post<FrameOutResponse>(
      `${url}`,
      this._shSharedHeaders.buildBody(request),
      {
        headers: this._shSharedHeaders.buildHeaders(request, envHeaders),
      }
    );
  }

  shGenericGetMethod(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    return this.http.post<FrameOutResponse>(
      `${url}`,
      this._shSharedHeaders.buildBody(request),
      {
        headers: this._shSharedHeaders.buildHeaders(request, envHeaders),
      }
    );
  }
}
